if (!customElements.get('cbj-collection-navigation')) {
  customElements.define('cbj-collection-navigation', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      const list = this.querySelector('ul');
      const toggle = this.querySelector('[data-cbj-expand]');
      const previous = this.querySelector('[data-cbj-previous]');
      const next = this.querySelector('[data-cbj-next]');
      if (!list || !toggle || !previous || !next) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const update = () => {
        previous.disabled = list.scrollLeft <= 1;
        next.disabled = list.scrollLeft + list.clientWidth >= list.scrollWidth - 1;
      };
      [toggle, previous, next].forEach(button => { button.hidden = false; });
      toggle.addEventListener('click', () => {
        const expanded = this.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', String(expanded));
        toggle.textContent = expanded ? toggle.dataset.showLess : toggle.dataset.showAll;
        previous.hidden = next.hidden = expanded;
        if (!expanded) list.scrollLeft = 0;
        update();
      }, options);
      const move = direction => list.scrollBy({ left: direction * list.clientWidth * .8, behavior: 'auto' });
      previous.addEventListener('click', () => move(-1), options);
      next.addEventListener('click', () => move(1), options);
      list.addEventListener('scroll', update, { ...options, passive: true });
      this.resizeObserver = new ResizeObserver(update);
      this.resizeObserver.observe(list);
      update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.resizeObserver?.disconnect();
    }
  });
}

